import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import Layout from '../pages/_layout/Layout';
import MainWrapper from './MainWrapper';
import Payment from '../components/e-commerce/payment/Payment';
import ProjectSummary from '../components/compliance/ProjectSummary';
import VendorSummary from '../components/vendor_assessments/VendorSummary';
import VendorAssesmentsHome from '../components/vendor_assessments_home/VendorAssessmentsHome';
import NewAssessment from '../components/assessment/Assessment';
import HipaaAssessment from '../components/assessment/components/HIPAA/HipaaAssessment';
import ISO9001Assessment from '../components/assessment/components/ISO/ISO9001Assessment';
import CybersecurityAssessment from '../components/assessment/components/NIST/CybersecurityAssessment';
import SRAMainPage from '../components/sra/SRAMainPage';
import SRASectionPage from '../components/sra/SRASectionPage';
import VendorQuestionnaire from '../components/vendor_assessments/VendorQuestionnaire';
import Assessment from '../components/assessment/WizardForm';
import ProfileAssessment from '../components/assessment/components/ProfileAssessment'
import PricingCards from '../components/pricing_cards/PricingCards'
import LogIn from '../components/account/log_in/LogIn'
import LogOut from '../components/account/log_in/Logout'
import ResetPassword from '../components/account/log_in/components/ResetPassword'
import Dashboard from '../components/dashboards/posture-dash/dashboard'
import Policies from '../components/policies/Policies'
import IncidentTemplate from '../components/policies/templates/Incident';
import ThirdPartyTemplate from '../components/policies/templates/ThirdParty';
import PrivacyTemplate from '../components/policies/templates/Privacy';
import Profile from '../components/account/profile/Profile';
import Recommendation from '../components/recommendations/Recommendations';
import Report from '../components/report/Report';
import UnAuthorized from '../components/account/log_in/components/UnAuthorized';
import Catalog from '../components/e-commerce/catalog/Catalog';
import ProductPage from '../components/e-commerce/product_page/ProductPage';
import ThirdPartyQuestionnaire from '../components/policies/questionnaire/ThirdPartyQuestionnaire_';
import IncidentQuestionnaire from '../components/policies/questionnaire/IncidentQuestionnaire';
import PaymentConfirmation from '../components/e-commerce/payment/components/PaymentConfirmation'
import Cart from '../components/e-commerce/cart/Cart'
import Invoice from '../components/invoice_template/InvoiceTemplate'
import Training from '../components/training/Training'
import HipaaTraining from '../components/training/HipaaTraining'
import PCITraining from '../components/training/PCITraining'
import VideoPage from '../components/training/components/VideoPage'
import RequireAuth from '../components/hoc/requireAuth';
import RequireUnAuth from '../components/hoc/requireUnAuth';
import NotFoundPage from '../components/PageNotFound';
import ChangePassword from '../components/account/log_in/components/ChangePassword';
import DataLoader from './DataLoader';
import GetStarted from '../components/get-started/GetStarted';
import GettingStarted from '../components/getting-started/GettingStarted';
import Content from '../components/content_management/Content';
import HIPAAPlaybookContent from '../components/content_management/HIPAAPlaybookContent';
import ControlContent from '../components/content_management/ControlContent';
import HelpTextEditor from '../components/content_management/HelpTextEditor';
import HipaaPlaybook from '../components/playbook/hipaa/HipaaPlaybook';
import frameworkMapping from '../utils/frameworkMapping'
import mockData from '../utils/mockData';
import moduleMapping from '../utils/moduleMapping'
import subModuleMapping from '../utils/subModuleMapping'
import LoadingWrapper from '../components/LoadingWrapper'
import CMMCAssessment from '../components/assessment/components/CMMC/CMMCAssessment'

import TourDashboard from '../components/tour/dashboard/TourDashboard';
import TourCatalog from '../components/tour/e-commerce/TourCatalog';
import TourHipaaPlaybook from '../components/tour/playbook/hipaa/TourHipaaPlaybook';
import TourCompliance from '../components/tour/compliance/TourProjectSummary';
import TourTraining from '../components/tour/training/TourTraining';

import Tracker from '../analytics/Tracker';
import HIPAAAwarenessQuiz from '../components/training/components/HIPAAAwarenessQuiz';
import PCIAwarenessQuiz from '../components/training/components/PCIAwarenessQuiz';
import SecurityAwareness from '../components/training/components/SecurityAwareness';
import PolicyGenerator from '../components/policy_generator/PolicyGenerator';
//import { truncate } from 'fs';
const tracker = new Tracker();

class Router extends Component {
  componentDidMount () {
    tracker.handleEvent(tracker.EVENTS.PAGE_VIEW, { path: this.props.location.pathname });
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      tracker.handleEvent(tracker.EVENTS.PAGE_VIEW, { path: this.props.location.pathname });
    }
  }

  wrappedRoutes = (props) => {
    return (
      <LoadingWrapper>
        <div>
          <Layout />
          <div className='container__wrap'>
            <Route path='/app' component={this.App} />
          </div>
        </div >
      </LoadingWrapper>)
  }

  onBoardingRoutes = () => (
    <div>
      <Layout />
      <div className='container__wrap'>
        <Route path='/onboarding' component={this.Onboarding} />
      </div>
    </div>
  )

  Onboarding = () => (
    <Switch>
      {/*
      <Route 
      path='/onboarding/assessment/company-profile' 
      component={RequireAuth(Assessment, { name: "Company Profile" })} />
      */}
      {/* <Route
        path='/onboarding/assessment/company-profile'
        component={RequireAuth(ProfileAssessment, { name: "Company Profile" })} /> */}
    </Switch>
  )

  App = () => {
    const complianceRoutes = Object.entries(frameworkMapping).map(([id, framework]) => {
      let routes = [];
      let mainRoute = <Route
        exact
        path={`/app/compliance/${framework.path}`}
        key={`${framework.name}-${framework.id}`}
        component={
          RequireAuth(ProjectSummary, {
            name: framework.humanName,
            compliance: framework.frameworkTitle,
            frameworkId: framework.id,
            description: framework.description,
            parse: framework.parse,
            path: framework.path,
            module: moduleMapping.COMPLIANCE,
            layout: framework.layout
          })} />
      routes.push(mainRoute)

      if (framework.flat === false) {
        let highLevelRoute = <Route
          exact
          key={`${framework.name}-${framework.id}-highLevel`}
          path={`/app/compliance/${framework.path}/:highLevelCategory`}
          component={RequireAuth(ProjectSummary, {
            name: framework.humanName,
            compliance: framework.humanName,
            description: framework.description,
            frameworkId: framework.id,
            parse: framework.parse,
            path: framework.path,
            module: moduleMapping.COMPLIANCE,
            layout: framework.layout
          })} />

        routes.push(highLevelRoute)
      }
      return routes;
    })

    const tourComplianceRoutes = Object.entries(mockData.frameworkMapping()).map(([id, framework]) => {
      let tourRoutes = [];
      let tourMainRoute = <Route
        exact
        path={`/app/tour/compliance/${framework.path}`}
        key={`${framework.name}-${framework.id}`}
        component={
          RequireAuth(TourCompliance, {
            name: framework.humanName,
            compliance: framework.frameworkTitle,
            frameworkId: framework.id,
            description: framework.description,
            parse: framework.parse,
            path: framework.path,
            module: moduleMapping.COMPLIANCE,
            layout: framework.layout
          })} />
      tourRoutes.push(tourMainRoute)

      if (framework.flat === false) {
        let highLevelRoute = <Route
          exact
          key={`${framework.name}-${framework.id}-highLevel`}
          path={`/app/tour/compliance/${framework.path}/:highLevelCategory`}
          component={RequireAuth(TourCompliance, {
            name: framework.humanName,
            compliance: framework.humanName,
            description: framework.description,
            frameworkId: framework.id,
            parse: framework.parse,
            path: framework.path,
            module: moduleMapping.COMPLIANCE,
            layout: framework.layout
          })} />

        tourRoutes.push(highLevelRoute)
      }
      return tourRoutes;
    })

    return (<Switch>
      <Route
        path='/app/assessment/gdpr'
        component={RequireAuth(Assessment, {
          name: "GDPR",
          module: moduleMapping.ASSESSMENT
        })} />
      <Route
        path='/app/assessment/company-profile'
        component={RequireAuth(ProfileAssessment, {
          name: "Company Profile",
          routeName: 'company-profile-assessment',
          excludeProfileValidation: true,
          module: moduleMapping.ASSESSMENT
        })} />
      <Route
        path='/app/assessment/hipaa-assessment'
        component={RequireAuth(HipaaAssessment, {
          name: "HIPAA Assessment",
          routeName: 'hipaa-assessment',
          excludeProfileValidation: true,
          module: moduleMapping.ASSESSMENT
        })} />
        <Route
        path='/app/assessment/iso9001-assessment'
        component={RequireAuth(ISO9001Assessment, {
          name: "ISO 9001 Assessment",
          routeName: 'iso9001-assessment',
          excludeProfileValidation: true,
          module: moduleMapping.ASSESSMENT
        })} />
      <Route
        path='/app/assessment/cmmc-assessment'
        component={RequireAuth(CMMCAssessment, {
          name: "CMMC Assessment",
          routeName: 'cmmc-assessment',
          excludeProfileValidation: true,
          module: moduleMapping.ASSESSMENT
        })} />
      <Route
        path='/app/assessment/nist-assessment'
        component={RequireAuth(CybersecurityAssessment, {
          name: "Cybersecurity Assessment",
          routeName: 'nist-assessment',
          excludeProfileValidation: true,
          module: moduleMapping.ASSESSMENT
        })} />
        <Route
        path='/app/assessment'
        component={RequireAuth(NewAssessment, {
          name: "Assessment",
          routeName: 'assessment',
          excludeProfileValidation: true,
          module: moduleMapping.ASSESSMENT
        })} />
      {/* <Route
        exact
        path='/app/assessment/security-risk-assessment'
        component={RequireAuth(SRAMainPage, {
          name: "HIPAA Security Risk Assessment",
          routeName: 'security-risk-assessment',
          excludeProfileValidation: true,
          module: moduleMapping.ASSESSMENT
        })} />
      <Route
        exact
        path='/app/assessment/security-risk-assessment/:sectionName'
        component={RequireAuth(SRASectionPage, {
          name: "HIPAA Security Risk Assessment",
          routeName: 'security-risk-assessment',
          excludeProfileValidation: true,
          module: moduleMapping.ASSESSMENT
        })} /> */}

      <Route path='/app/tour/dashboard' component={RequireAuth(TourDashboard)} />
      <Route path='/app/tour/marketplace' component={RequireAuth(TourCatalog)} />
      <Route path='/app/tour/playbook' component={RequireAuth(TourHipaaPlaybook)} />
      <Route path='/app/tour/training' component={RequireAuth(TourTraining)}/>

      {tourComplianceRoutes.flat()}
      
      <Route path='/app/payments/updatepayment' component={RequireAuth(Payment)} />
      <Route path='/app/payments/confirmation' component={RequireAuth(PaymentConfirmation)} />

      {/* Compliance Routes Start*/}
      {complianceRoutes.flat()}
      {/* Compliance Routes End*/}

      <Route path='/app/payments/pricingcards' component={RequireAuth(PricingCards)} />

      <Route exact path='/app/vendor-assessments' component={RequireAuth(VendorAssesmentsHome)} />
      <Route exact path='/app/vendor-assessments/results' component={RequireAuth(VendorSummary)} />
      <Route exact path='/app/vendor-assessments/view' component={RequireAuth(VendorQuestionnaire)} />
      
      {/* <Route exact path='/app/training' component={RequireAuth(Training)} /> */}
      <Route exact path='/app/training/security' component={
        RequireAuth(Training,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.SECURITY_TRAINING})} 
      />

      {/* PCI Training Routes */}
      <Route exact path='/app/training/pci' component={
        RequireAuth(PCITraining,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.PCI_TRAINING})} 
      />

      <Route exact path='/app/training/pciawarenessquiz' component={
        RequireAuth(PCIAwarenessQuiz,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.PCI_TRAINING})} 
      />

      <Route exact path='/app/training/hipaa' component={
        RequireAuth(HipaaTraining,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.HIPAA_TRAINING})} />

      <Route exact path='/app/training/hipaaawarenessquiz' component={
        RequireAuth(HIPAAAwarenessQuiz,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.HIPAA_TRAINING})} />

      
      <Route exact path='/app/training/securityawareness' component={
        RequireAuth(SecurityAwareness,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.SECURITY_TRAINING})} />

      {/* <Route exact path='/app/training/:trainingType' component={RequireAuth(Training)} /> */}

      {/*<Route exact path= '/app/training/hipaa/:tag' component={RequireAuth(NotFoundPage)} />*/}

      <Route exact path='/app/training/:trainingType/:tag' component={
        RequireAuth(VideoPage,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.SECURITY_TRAINING})} />

      <Route exact path='/app/training/:trainingType/:tag' component={
        RequireAuth(VideoPage,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.HIPAA_TRAINING})} />

      <Route exact path='/app/training/:trainingType/:tag' component={
        RequireAuth(VideoPage,{module:moduleMapping.TRAINING, sub_module:subModuleMapping.PCI_TRAINING})} />
      
      <Route exact path='/app/dashboard' component={RequireAuth(Dashboard, { excludeProfileValidation: true })} />

      <Route path='/app/playbook/hipaa'
        component={RequireAuth(HipaaPlaybook, {
          module: moduleMapping.PLAYBOOK
        })} />

      {/* Policy Generator Questionnaire routes  */}
      <Route exact path='/app/policies/incident-policy-questions' component={RequireAuth(IncidentQuestionnaire)} />
      <Route
        exact path='/app/policies/third-party-policy-questions'
        component={RequireAuth(ThirdPartyQuestionnaire)} />



      <Route exact path='/app/policies/incident' component={RequireAuth(IncidentTemplate)} />
      <Route exact path='/app/policies/thirdparty' component={RequireAuth(ThirdPartyTemplate)} />
      <Route exact path='/app/policies/privacy' component={RequireAuth(PrivacyTemplate)} />

      <Route path='/app/policies' component={RequireAuth(Policies)} />
      <Route path='/app/policy-generator' component={RequireAuth(PolicyGenerator)} />


      <Route path='/app/user/profile' component={RequireAuth(Profile)} />
      {/*<Route path='/app/posture-report' component={RequireAuth(Report)} />*/}
      <Route path='/app/recommendations' component={RequireAuth(Recommendation)} />

      {/* Marketplace Routes */}
      <Route path='/app/marketplace/product/:tag'
        component={RequireAuth(ProductPage, {
          module: moduleMapping.MARKETPLACE
        })} />
      <Route path='/app/marketplace/cart'
        component={RequireAuth(Cart, {
          module: moduleMapping.MARKETPLACE
        })} />
      <Route path='/app/marketplace/invoice'
        component={RequireAuth(Invoice, {
          module: moduleMapping.MARKETPLACE
        })} />
      <Route path='/app/marketplace'
        component={RequireAuth(Catalog, {
          module: moduleMapping.MARKETPLACE
        })} />

      {/*<Route path='/app/get-started' component={RequireAuth(GetStarted)} />*/}
      <Route path='/app/getting-started' component={RequireAuth(GettingStarted)} />

      {/* Content Editor Routes*/}
      <Route exact path='/app/content/hipaa-playbook' component={RequireAuth(HIPAAPlaybookContent, {
        name: "HIPAA Playbook Content",
        routeName: 'hipaa-playbook',
        excludeProfileValidation: true
      })} />
      <Route path='/app/content' component={RequireAuth(Content, {
        name: "Content Page",
        routeName: 'help-text-editor', excludeProfileValidation: true
      })} />
      <Route path='/app/control_content/:frameworkName/:control_name'
        component={RequireAuth(ControlContent, {
          name: "Control Content Page (LL)",
          routeName: 'help-text-editor', excludeProfileValidation: true,
          parse: true
        })} />
      <Route path='/app/control_content/:frameworkName' component={RequireAuth(ControlContent, {
        name: "Control Content Page (HL)",
        routeName: 'help-text-editor', excludeProfileValidation: true,
        frameworkId: 2,
        parse: true
      })} />
      <Route path='/app/editor/:frameworkName/:highlevel_category/:lowlevel_category/:control_id'
        component={RequireAuth(HelpTextEditor, {
          name: "Help Text Editor",
          routeName: 'help-text-editor', excludeProfileValidation: true
        })} />
      <Route path='/app/editor/:frameworkName/:lowlevel_category/:control_id'
        component={RequireAuth(HelpTextEditor, {
          name: "Help Text Editor",
          routeName: 'help-text-editor', excludeProfileValidation: true
        })} />
      <Route component={RequireAuth(NotFoundPage)} />
    </Switch>)
  };



  render () {
    return <MainWrapper>
      <main>
        <DataLoader>
          <Switch>
            <Route exact path='/unauthorized' component={UnAuthorized} />
            <Route exact path='/' component={RequireUnAuth(LogIn)} />
            <Route path='/login' component={RequireUnAuth(LogIn)} />
            <Route path='/logout' component={LogOut} />
            <Route path='/recover-password' component={RequireUnAuth(ResetPassword)} />
            <Route path='/change-password' component={RequireUnAuth(ChangePassword)} />
            <Route path='/app' component={RequireAuth(this.wrappedRoutes)} />
            <Route path='/onboarding' component={this.onBoardingRoutes} />
            <Route component={RequireAuth(NotFoundPage)} />
          </Switch>
        </DataLoader>
      </main>
    </MainWrapper>
  };
};

export default withRouter(Router);


// WEBPACK FOOTER //
// ./src/app/Router.js